// extracted by mini-css-extract-plugin
export default {"spinnerBackground":"Spinner_spinnerBackground__Sjb2O","spinner":"Spinner_spinner__H2HDD","spin":"Spinner_spin__DSOqJ"};